import React, { useEffect, useState } from "react";
import { Button, Container, Grid, TextField } from "@material-ui/core";
import { toast } from "react-toastify";
import api from "../../services/api";
import { mensagemErro, nomePerfil } from "../../services/acesso";

const MeuCadastro = () => {
    const [name, setName] = useState("");
    const [telephone, setTelephone] = useState("");
    const [email, setEmail] = useState("");
    const [perfil, setPerfil] = useState("");
    const [senhaAtual, setSenhaAtual] = useState("");
    const [password, setPassword] = useState("");
    const [passwordConfirmation, setPasswordConfirmation] = useState("");
    const [salvando, setSalvando] = useState(false);
    const [trocando, setTrocando] = useState(false);

    useEffect(() => {
        api.get("meu-cadastro").then((result) => {
            setName(result.data?.name || "");
            setTelephone(result.data?.telephone || "");
            setEmail(result.data?.email || "");
            setPerfil(result.data?.perfil || "");
        }).catch((e) => {
            toast.error(mensagemErro(e, "Não foi possível carregar o cadastro"));
        });
    }, []);

    const salvar = async () => {
        if (!name) {
            toast.error("Informe o nome");
            return;
        }
        setSalvando(true);
        try {
            await api.patch("meu-cadastro", { name, telephone });
            localStorage.setItem("name", name);
            toast.success("Cadastro atualizado");
        } catch (e) {
            toast.error(mensagemErro(e, "Não foi possível salvar"));
        } finally {
            setSalvando(false);
        }
    };

    const trocarSenha = async () => {
        if (!senhaAtual) {
            toast.error("Informe a senha atual");
            return;
        }
        if (!password || password.length < 8) {
            toast.error("A nova senha precisa ter no mínimo 8 caracteres");
            return;
        }
        if (password !== passwordConfirmation) {
            toast.error("A confirmação da senha não confere");
            return;
        }
        setTrocando(true);
        try {
            await api.patch("meu-cadastro/senha", {
                senha_atual: senhaAtual,
                password,
                password_confirmation: passwordConfirmation,
            });
            setSenhaAtual("");
            setPassword("");
            setPasswordConfirmation("");
            toast.success("Senha alterada");
        } catch (e) {
            toast.error(mensagemErro(e, "Não foi possível alterar a senha"));
        } finally {
            setTrocando(false);
        }
    };

    return (
        <Container fixed>
            <h1>Meu cadastro</h1>
            <div style={{ backgroundColor: "#fff", padding: 16 }}>
                <Grid container spacing={2}>
                    <Grid item xs={4}>
                        <TextField label="Nome" value={name} onChange={(e) => setName(e.target.value)} fullWidth required />
                    </Grid>
                    <Grid item xs={4}>
                        <TextField label="Telefone" value={telephone} onChange={(e) => setTelephone(e.target.value)} fullWidth />
                    </Grid>
                    <Grid item xs={4}>
                        <TextField label="E-mail" value={email} fullWidth disabled />
                    </Grid>
                    <Grid item xs={4}>
                        <TextField label="Perfil" value={nomePerfil(perfil)} fullWidth disabled />
                    </Grid>
                </Grid>
                <div style={{ marginTop: 20 }}>
                    <Button variant="contained" color="primary" disabled={salvando} onClick={salvar}>Salvar</Button>
                </div>
                <h3 style={{ marginTop: 32, color: "#726e6e" }}>Trocar senha</h3>
                <Grid container spacing={2}>
                    <Grid item xs={4}>
                        <TextField type="password" label="Senha atual" value={senhaAtual} onChange={(e) => setSenhaAtual(e.target.value)} fullWidth />
                    </Grid>
                    <Grid item xs={4}>
                        <TextField type="password" label="Nova senha" value={password} onChange={(e) => setPassword(e.target.value)} helperText="Mínimo de 8 caracteres" fullWidth />
                    </Grid>
                    <Grid item xs={4}>
                        <TextField type="password" label="Confirmar nova senha" value={passwordConfirmation} onChange={(e) => setPasswordConfirmation(e.target.value)} fullWidth />
                    </Grid>
                </Grid>
                <div style={{ marginTop: 20 }}>
                    <Button variant="contained" color="primary" disabled={trocando} onClick={trocarSenha}>Alterar senha</Button>
                </div>
            </div>
        </Container>
    );
};

export default MeuCadastro;
